import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0;
  overflow-y: auto;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
  border-bottom: ${(props) => props.borderBottom ?? "0px"};
`;

export const ProductContainer = styled.section`
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 2px 3px 5px;
  background-color: white;
  padding: 10px 10px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #cccccc;
  margin-bottom: 10px;
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#00aeea"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
`;
